import { render } from "./mainlayout.vue?vue&type=template&id=6698f486&scoped=true"
import script from "./mainlayout.vue?vue&type=script&lang=js"
export * from "./mainlayout.vue?vue&type=script&lang=js"

import "./mainlayout.vue?vue&type=style&index=0&id=6698f486&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6698f486"]])

export default __exports__